import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { getSupportWorkingHours } from "../utils/timezone";
export var OperatingTime = function OperatingTime(_ref) {
  var color = _ref.color,
    supportType = _ref.supportType;
  var _getSupportWorkingHou = getSupportWorkingHours(supportType),
    formattedEndHours = _getSupportWorkingHou.formattedEndHours,
    formattedStartHours = _getSupportWorkingHou.formattedStartHours,
    formattedTimezone = _getSupportWorkingHou.formattedTimezone;
  if (!formattedStartHours || !formattedEndHours || !formattedTimezone) {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "paragraphSansRegular",
      color: color
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "fu3fT7",
      defaultMessage: "Mon-Fri, 9AM-8PM EST"
    }));
  }
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular",
    color: color
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fEdatR",
    defaultMessage: "Mon-Fri, {StartTime}AM-{EndTime}PM {TimeZoneTime}",
    values: {
      StartTime: formattedStartHours,
      EndTime: formattedEndHours,
      TimeZoneTime: formattedTimezone
    }
  }));
};